module.exports = __webpack_public_path__ + "static/img/banner2.6a327b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2.png
// module id = pMVX
// module chunks = 13